// src/context/ResourceMenuContext.js
import { createContext, useContext, useState } from "react";

const ResourceMenuContext = createContext();

export const useResourceMenu = () => useContext(ResourceMenuContext);

export const ResourceMenuProvider = ({ children }) => {
  const [anchorElAddResource, setAnchorElAddResource] = useState(null);

  return (
    <ResourceMenuContext.Provider value={{ anchorElAddResource, setAnchorElAddResource }}>
      {children}
    </ResourceMenuContext.Provider>
  );
};
